export type Creche = {
  slug: string;
  nom: string;
  ville: string;
  adresse: string;
  codePostal: string;
  email: string;
  telephone?: string;
  superficie: number;
  superficieJardin: number;
  libelleExterieur?: string;
  superficieRecord?: boolean;
  capacite: number;
  agesAccueillis: string;
  horaires: {
    ouverture: string;
    fermeture: string;
    jours: string[];
  };
  fermeturesAnnuelles: string[];
  motDirectrice: {
    auteur: string;
    texte: string;
    photo: string;
  };
  photoPrincipale: string;
  galerie: string[];
  photosDisponibles?: boolean;
  coordonnees: { lat: number; lng: number };
  disponibilites: {
    lundi: number;
    mardi: number;
    mercredi: number;
    jeudi: number;
    vendredi: number;
  };
};

const horairesStandard = {
  ouverture: "08:00",
  fermeture: "18:30",
  jours: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi"],
};

const fermeturesStandard = [
  "3 semaines en août",
  "1 semaine à Noël",
];

export const creches: Creche[] = [
  {
    slug: "isneauville",
    nom: "Isneauville - Symphonie",
    ville: "Saint-Martin-du-Vivier",
    adresse: "232 Rue Delamare Deboutteville",
    codePostal: "76230",
    email: "elodie@lalalandcreches.com",
    superficie: 170,
    superficieJardin: 20,
    superficieRecord: true,
    capacite: 12,
    agesAccueillis: "10 semaines à 5 ans",
    horaires: horairesStandard,
    fermeturesAnnuelles: fermeturesStandard,
    motDirectrice: {
      auteur: "Elodie",
      texte:
        "Bienvenue dans la plus grande micro-crèche de la région avec ses 170 m² d'espace entièrement neuf et son jardin extérieur. Nous offrons à vos enfants un cadre sécurisé, stimulant et chaleureux, où ils peuvent s'épanouir pleinement. En plus des activités variées, nous proposons également des ateliers musicaux pour éveiller leurs sens et nourrir leur créativité. Notre équipe passionnée est là pour veiller à ce que chaque jour soit une nouvelle aventure enrichissante.",
      photo: "/images/creches/isneauville-directrice.jpg",
    },
    photoPrincipale: "/images/creches/isneauville-hero.jpg",
    galerie: [
      "/images/creches/isneauville-1.jpg",
      "/images/creches/isneauville-2.jpg",
      "/images/creches/isneauville-3.jpg",
      "/images/creches/isneauville-4.jpg",
      "/images/creches/isneauville-5.jpg",
      "/images/creches/isneauville-6.jpg",
      "/images/creches/isneauville-7.jpg",
      "/images/creches/isneauville-8.jpg",
      "/images/creches/isneauville-9.jpg",
    ],
    photosDisponibles: true,
    coordonnees: { lat: 49.4889, lng: 1.1331 },
    disponibilites: { lundi: 1, mardi: 1, mercredi: 1, jeudi: 1, vendredi: 1 },
  },
  {
    slug: "maestro-notre-dame-de-bondeville",
    nom: "Notre-Dame-de-Bondeville 1 - Maestro",
    ville: "Notre-Dame-de-Bondeville",
    adresse: "763 rue des Longs Vallons",
    codePostal: "76960",
    email: "cindy@lalalandcreches.com",
    superficie: 120,
    superficieJardin: 40,
    capacite: 12,
    agesAccueillis: "10 semaines à 5 ans",
    horaires: horairesStandard,
    fermeturesAnnuelles: fermeturesStandard,
    motDirectrice: {
      auteur: "Cindy",
      texte:
        "C'est avec un immense plaisir que je vous souhaite la bienvenue à la crèche de Notre-Dame-de-Bondeville. Notre équipe, présente depuis plusieurs années, est composée de professionnelles passionnées qui s'engagent à offrir un environnement chaleureux et stimulant. Nous proposons des activités musicales hebdomadaires pour éveiller la créativité de vos petits.",
      photo: "/images/creches/maestro-directrice.jpg",
    },
    photoPrincipale: "/images/creches/maestro-1.jpg",
    galerie: [
      "/images/creches/maestro-2.jpg",
      "/images/creches/maestro-3.jpg",
    ],
    photosDisponibles: true,
    coordonnees: { lat: 49.4861, lng: 1.0394 },
    disponibilites: { lundi: 1, mardi: 1, mercredi: 0, jeudi: 1, vendredi: 1 },
  },
  {
    slug: "arpege-notre-dame-de-bondeville",
    nom: "Notre-Dame-de-Bondeville 2 - Arpège",
    ville: "Notre-Dame-de-Bondeville",
    adresse: "12 rue de l'Abbaye",
    codePostal: "76960",
    email: "fabienne@lalalandcreches.com",
    superficie: 170,
    superficieJardin: 0,
    capacite: 10,
    agesAccueillis: "10 semaines à 5 ans",
    horaires: horairesStandard,
    fermeturesAnnuelles: fermeturesStandard,
    motDirectrice: {
      auteur: "Estelle",
      texte:
        "C'est avec un immense plaisir que je vous souhaite la bienvenue à la seconde crèche La La Land de Notre-Dame-de-Bondeville.\n\nNotre équipe de professionnelles est pleinement engagée à accompagner vos petits avec douceur et enthousiasme.\n\nIci, la musique occupe une place toute particulière : elle rythme le quotidien des enfants et éveille leur sensibilité et leur créativité dès le plus jeune âge.\n\nNous croyons également aux bienfaits du grand air et des découvertes, c'est pourquoi nous favorisons les sorties régulières pour permettre à vos enfants d'explorer le monde qui les entoure.\n\nÀ très bientôt !",
      photo: "/images/creches/arpege-directrice.jpg",
    },
    photoPrincipale: "/images/creches/arpege-hero.jpg",
    galerie: [
      "/images/creches/arpege-1.jpg",
      "/images/creches/arpege-2.jpg",
    ],
    photosDisponibles: true,
    coordonnees: { lat: 49.4895, lng: 1.0432 },
    disponibilites: { lundi: 2, mardi: 1, mercredi: 1, jeudi: 0, vendredi: 2 },
  },
  {
    slug: "armonia-saint-etienne-du-rouvray",
    nom: "Saint-Etienne-du-Rouvray - Harmonia",
    ville: "Saint-Étienne-du-Rouvray",
    adresse: "111 rue Léon Gambetta",
    codePostal: "76800",
    email: "pascaline@lalalandcreches.com",
    superficie: 140,
    superficieJardin: 80,
    capacite: 12,
    agesAccueillis: "10 semaines à 5 ans",
    horaires: horairesStandard,
    fermeturesAnnuelles: [
      "3 semaines en août",
      "1 semaine à Noël",
      "1 semaine en avril",
    ],
    motDirectrice: {
      auteur: "Pascaline",
      texte:
        "Je suis fière de diriger la première micro-crèche indépendante de Saint-Etienne-du-Rouvray.\n\nNotre établissement est tout neuf, ayant ouvert ses portes en mai 2024, et est dédié à l'épanouissement des tout-petits.\n\nN'hésitez pas à nous contacter pour toute question ou pour organiser une visite. Nous serons ravis de vous accueillir et de vous faire découvrir notre nouvelle micro-crèche.\n\nÀ très bientôt !",
      photo: "/images/creches/armonia-directrice.jpg",
    },
    photoPrincipale: "/images/creches/armonia-hero.jpg",
    galerie: [
      "/images/creches/armonia-1.jpg",
      "/images/creches/armonia-2.jpg",
    ],
    photosDisponibles: true,
    coordonnees: { lat: 49.3853, lng: 1.1051 },
    disponibilites: { lundi: 1, mardi: 0, mercredi: 2, jeudi: 1, vendredi: 1 },
  },
  {
    slug: "msa1-mont-saint-aignan",
    nom: "Mont-Saint-Aignan 1 - Muses",
    ville: "Mont-Saint-Aignan",
    adresse: "6 rue Georges Charpak",
    codePostal: "76130",
    email: "fabienne@lalalandcreches.com",
    superficie: 160,
    superficieJardin: 100,
    capacite: 12,
    agesAccueillis: "10 semaines à 5 ans révolus",
    horaires: horairesStandard,
    fermeturesAnnuelles: fermeturesStandard,
    motDirectrice: {
      auteur: "Fabienne",
      texte:
        "Notre priorité est de créer un cadre chaleureux et sécurisé où chaque enfant peut s'épanouir et grandir en toute sérénité.\n\nNous proposons une variété d'activités ludiques et éducatives, avec un focus particulier sur les ateliers musicaux pour encourager la créativité et le développement des enfants.\n\nPour plus d'informations ou pour organiser une visite, n'hésitez pas à nous contacter. Nous serons enchantés de vous accueillir et de vous faire découvrir notre micro-crèche.\n\nÀ très bientôt !",
      photo: "/images/creches/msa1-directrice.jpg",
    },
    photoPrincipale: "/images/creches/msa1-hero.jpg",
    galerie: [
      "/images/creches/msa1-1.jpg",
      "/images/creches/msa1-2.jpg",
      "/images/creches/msa1-3.jpg",
    ],
    photosDisponibles: true,
    coordonnees: { lat: 49.4642, lng: 1.0709 },
    disponibilites: { lundi: 1, mardi: 1, mercredi: 1, jeudi: 1, vendredi: 0 },
  },
  {
    slug: "msa2-mont-saint-aignan",
    nom: "Mont-Saint-Aignan 2 - Les P’tits Accords",
    ville: "Mont-Saint-Aignan",
    adresse: "6 rue Georges Charpak",
    codePostal: "76130",
    email: "fabienne@lalalandcreches.com",
    superficie: 160,
    superficieJardin: 100,
    capacite: 12,
    agesAccueillis: "10 semaines à 5 ans révolus",
    horaires: horairesStandard,
    fermeturesAnnuelles: fermeturesStandard,
    motDirectrice: {
      auteur: "Louise",
      texte:
        "Situé au coeur de La Vatine, notre établissement est dédié à l'épanouissement des tout-petits dans un environnement chaleureux et sécurisé.\n\nNous offrons des activités variées, notamment des ateliers musicaux, pour stimuler le développement des enfants.\n\nN'hésitez pas à nous contacter pour toute question ou pour organiser une visite. Nous serons ravis de vous accueillir !\n\nÀ bientôt,",
      photo: "/images/creches/msa2-directrice.jpg",
    },
    photoPrincipale: "/images/creches/msa2-hero.jpg",
    galerie: [
      "/images/creches/msa2-1.jpg",
      "/images/creches/msa2-2.jpg",
    ],
    photosDisponibles: true,
    coordonnees: { lat: 49.4644, lng: 1.0712 },
    disponibilites: { lundi: 0, mardi: 2, mercredi: 1, jeudi: 1, vendredi: 1 },
  },
  {
    slug: "cde-vernon",
    nom: "Vernon (Campus de l’Espace) - Hautbois",
    ville: "Vernon",
    adresse: "Campus de l'Espace, 5 allée Saint-Michel",
    codePostal: "27200",
    email: "leticia@lalalandcreches.com",
    superficie: 140,
    superficieJardin: 80,
    capacite: 12,
    agesAccueillis: "10 semaines à 6 ans",
    horaires: horairesStandard,
    fermeturesAnnuelles: fermeturesStandard,
    motDirectrice: {
      auteur: "Léticia",
      texte:
        "Niché dans la forêt Vernonnaise, notre micro-crèche le Hautbois offre le calme, l'apaisement et l'épanouissement de chaque enfant. Nous avons fait de ce lieu un cocon chaleureux où chaque enfant peut développer son individualité au sein du groupe.\n\nEn plus d'assurer la sécurité physique et affective de chacun des enfants, notre équipe pédagogique offre de nombreuses activités d'éveil ludiques et éducatives en lien avec les besoins observés. La musique est au cœur de notre quotidien.\n\nIl nous tient à cœur de travailler en étroite collaboration avec les familles afin d'assurer un accueil individualisé et personnalisé dans la plus grande bienveillance.\n\nSi nos valeurs sont aussi les vôtres, n'hésitez pas à nous contacter et nous nous ferons un plaisir de répondre à toutes vos questions ou d'organiser la visite de notre micro-crèche.\n\nÀ très bientôt.",
      photo: "/images/creches/vernon-directrice.jpg",
    },
    photoPrincipale: "/images/creches/vernon-hero.jpg",
    galerie: [
      "/images/creches/vernon-1.jpg",
      "/images/creches/vernon-2.jpg",
    ],
    photosDisponibles: true,
    coordonnees: { lat: 49.0968, lng: 1.4836 },
    disponibilites: { lundi: 2, mardi: 1, mercredi: 1, jeudi: 2, vendredi: 1 },
  },
  {
    slug: "stm1-saint-marcel",
    nom: "Saint-Marcel 1 - Carillons",
    ville: "Saint-Marcel",
    adresse: "13 rue de la Croix-Blanche",
    codePostal: "27950",
    email: "emilie@lalalandcreches.com",
    superficie: 140,
    superficieJardin: 80,
    capacite: 12,
    agesAccueillis: "10 semaines à 6 ans",
    horaires: horairesStandard,
    fermeturesAnnuelles: fermeturesStandard,
    motDirectrice: {
      auteur: "Emilie",
      texte:
        "Nos locaux, situés stratégiquement au cœur de la zone commerciale et industrielle de Saint-Marcel, offrent un accès pratique pour les parents travaillant à proximité.\n\nLes espaces de jeu, tant intérieurs qu'extérieurs, sont soigneusement aménagés pour stimuler la curiosité et l'éveil des enfants tout en garantissant leur sécurité.\n\nPour plus d'informations ou pour organiser une visite, n'hésitez pas à nous contacter. Nous serons enchantés de vous accueillir et de vous faire découvrir notre micro-crèche.\n\nÀ très bientôt !",
      photo: "/images/creches/stm1-directrice.jpg",
    },
    photoPrincipale: "/images/creches/stm1-hero.jpg",
    galerie: [
      "/images/creches/stm1-1.jpg",
      "/images/creches/stm1-2.jpg",
    ],
    photosDisponibles: true,
    coordonnees: { lat: 49.0972, lng: 1.3989 },
    disponibilites: { lundi: 1, mardi: 1, mercredi: 0, jeudi: 1, vendredi: 1 },
  },
  {
    slug: "stm2-saint-marcel",
    nom: "Saint-Marcel 2 - Pianotins",
    ville: "Saint-Marcel",
    adresse: "13 rue de la Croix-Blanche",
    codePostal: "27950",
    email: "emilie@lalalandcreches.com",
    superficie: 140,
    superficieJardin: 80,
    capacite: 12,
    agesAccueillis: "10 semaines à 6 ans",
    horaires: horairesStandard,
    fermeturesAnnuelles: fermeturesStandard,
    motDirectrice: {
      auteur: "Emilie",
      texte:
        "Notre micro-crèche, les Pianotins, accueille vos enfants dans un esprit de sérénité et de quiétude.\n\nNotre mission est d'accompagner chaque enfant vers l'autonomie qui le rendra fier de lui.\n\nNous proposons des activités diverses qui stimuleront tous ses sens et la musique fait partie intégrante de la vie à la crèche.\n\nNous avons hâte de vous accueillir, alors n'hésitez pas, contactez-nous pour venir découvrir nos espaces et répondre à toutes vos questions.\n\nÀ très vite.",
      photo: "/images/creches/stm2-directrice.jpg",
    },
    photoPrincipale: "/images/creches/stm2-hero.jpg",
    galerie: [
      "/images/creches/stm2-1.jpg",
      "/images/creches/stm2-2.jpg",
    ],
    photosDisponibles: true,
    coordonnees: { lat: 49.0974, lng: 1.3992 },
    disponibilites: { lundi: 0, mardi: 1, mercredi: 1, jeudi: 0, vendredi: 2 },
  },
  {
    slug: "rouen-beauvoisine",
    nom: "Rouen Beauvoisine - Tempo",
    ville: "Rouen",
    adresse: "66 rue Beauvoisine",
    codePostal: "76000",
    email: "fabienne@lalalandcreches.com",
    superficie: 120,
    superficieJardin: 0,
    superficieRecord: true,
    capacite: 10,
    agesAccueillis: "10 semaines à 5 ans",
    horaires: horairesStandard,
    fermeturesAnnuelles: fermeturesStandard,
    motDirectrice: {
      auteur: "Fanny",
      texte:
        "Bienvenue dans notre nouvelle crèche au 66 rue Beauvoisine !\n\nIci, tout a été pensé pour offrir à vos enfants un lieu doux, joyeux et sécurisé, où ils peuvent grandir, s'éveiller et s'épanouir à leur rythme.\n\nChaque jour, notre équipe propose des activités variées, des moments de jeux, de découvertes, et des ateliers musicaux pour éveiller leur curiosité. Des sorties sont organisées chaque semaine pour profiter des parcs, des Beaux Arts…\n\nAu plaisir de vous rencontrer,",
      photo: "/images/creches/beauvoisine-directrice.jpg",
    },
    photoPrincipale: "/images/creches/beauvoisine-hero.jpg",
    galerie: [
      "/images/creches/beauvoisine-1.jpg",
      "/images/creches/beauvoisine-2.jpg",
      "/images/creches/beauvoisine-3.jpg",
    ],
    photosDisponibles: true,
    coordonnees: { lat: 49.4488, lng: 1.0985 },
    disponibilites: { lundi: 1, mardi: 1, mercredi: 1, jeudi: 1, vendredi: 1 },
  },
  {
    slug: "rouen-malouet",
    nom: "Rouen Malouet - Sonatine",
    ville: "Rouen",
    adresse: "13 rue Malouet",
    codePostal: "76100",
    email: "fabienne@lalalandcreches.com",
    superficie: 130,
    superficieJardin: 0,
    capacite: 12,
    agesAccueillis: "10 semaines à 5 ans",
    horaires: horairesStandard,
    fermeturesAnnuelles: fermeturesStandard,
    motDirectrice: {
      auteur: "À compléter",
      texte: "À compléter",
      photo: "",
    },
    photoPrincipale: "/images/creches/malouet-hero.jpg",
    galerie: [
      "/images/creches/malouet-1.jpg",
    ],
    photosDisponibles: true,
    coordonnees: { lat: 49.432, lng: 1.0909 },
    disponibilites: { lundi: 0, mardi: 0, mercredi: 0, jeudi: 0, vendredi: 0 },
  },
  {
    slug: "rouen-saint-vivien",
    nom: "Rouen Saint-Vivien - Mélodie",
    ville: "Rouen",
    adresse: "10 place Saint-Vivien",
    codePostal: "76000",
    email: "fabienne@lalalandcreches.com",
    superficie: 148,
    superficieJardin: 40,
    libelleExterieur: "Extérieur",
    capacite: 12,
    agesAccueillis: "10 semaines à 5 ans",
    horaires: horairesStandard,
    fermeturesAnnuelles: fermeturesStandard,
    motDirectrice: {
      auteur: "À compléter",
      texte: "À compléter",
      photo: "",
    },
    photoPrincipale: "/images/creches/saint-vivien-hero.jpg",
    galerie: [
      "/images/creches/saint-vivien-1.jpg",
      "/images/creches/saint-vivien-2.jpg",
    ],
    photosDisponibles: true,
    coordonnees: { lat: 49.4413, lng: 1.1035 },
    disponibilites: { lundi: 0, mardi: 0, mercredi: 0, jeudi: 0, vendredi: 0 },
  },
];

export const libelleExterieur = (c: Creche): string =>
  c.libelleExterieur ?? "Jardin";

export const getCrecheBySlug = (slug: string): Creche | undefined =>
  creches.find((c) => c.slug === slug);

export const totalDispos = (c: Creche): number =>
  c.disponibilites.lundi +
  c.disponibilites.mardi +
  c.disponibilites.mercredi +
  c.disponibilites.jeudi +
  c.disponibilites.vendredi;

export const formatAdresseComplete = (c: Creche): string =>
  `${c.adresse}, ${c.codePostal} ${c.ville}`;

export const isPlaceholder = (value: string): boolean =>
  value === "À compléter";

export const dayLabels = [
  ["lundi", "Lundi"],
  ["mardi", "Mardi"],
  ["mercredi", "Mercredi"],
  ["jeudi", "Jeudi"],
  ["vendredi", "Vendredi"],
] as const;
